

export const GPT_KEY = process.env.REACT_APP_GPT_KEY;